module.exports = "<h1>Connect</h1>\n<p>Deze pagina is bewust leeg gelaten.</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/no-content/no-content.component.html
// module id = ./src/app/no-content/no-content.component.html
// module chunks = main